import { Eye, EyeOff } from "lucide-react";
import * as React from "react";

import { cn } from "@/lib/cn";

type PasswordInputProps = Omit<React.ComponentProps<"input">, "type">;

const PasswordInput = ({ className, ...props }: PasswordInputProps) => {
  const [showPassword, setShowPassword] = React.useState(false);

  return (
    <div className="relative">
      <input
        type={showPassword ? "text" : "password"}
        data-slot="input"
        className={cn(
          // Layout
          "flex h-12 w-full px-4 py-3 pr-12",
          // Background & Border
          "rounded-sm bg-neutral-200/2",
          "border-2 border-transparent transition-colors",
          // Typography
          "fs-300 font-semibold text-neutral-200",
          // Placeholder
          "placeholder:font-semibold placeholder:text-neutral-200/22",
          // Hover state
          "hover:border-neutral-200/22",
          // Focus state
          "focus-visible:border-primary-800/63 focus-visible:outline-none",
          // Disabled state
          "disabled:pointer-events-none disabled:cursor-not-allowed disabled:text-neutral-200/12",
          // Invalid state
          "aria-invalid:border-danger",
          // Autofill - neutral-900 bg (dark), neutral-200 text
          "autofill:shadow-[inset_0_0_0px_1000px_#101012] autofill:[-webkit-text-fill-color:#bfbfbf]",
          className
        )}
        {...props}
      />
      <button
        type="button"
        onClick={() => setShowPassword(!showPassword)}
        className="text-primary-400 hover:text-primary-500 absolute top-1/2 right-4 -translate-y-1/2 cursor-pointer transition-colors"
        tabIndex={-1}
        aria-label={showPassword ? "Скрыть пароль" : "Показать пароль"}
      >
        {showPassword ? <EyeOff className="size-5" /> : <Eye className="size-5" />}
      </button>
    </div>
  );
};

export { PasswordInput };
